import { FC, PropsWithChildren } from "react";
import { Page as CorePage, PageProps as CorePageProps} from "am-tax-fe-core";
import { useLocation } from "react-router-dom";
import { IconUser } from "@tabler/icons-react";
import { Image, useColorModeValue} from "@chakra-ui/react";
import ETRALogo from '/assets/header/ETRALogo.png';

export type PageProps = PropsWithChildren<Omit<CorePageProps, "location" | "menuItems">>;

export const Page: FC<PageProps> = ({ children, ...pageProps }) => {
    const location = useLocation();
    const iconColor = useColorModeValue("blue.500", "gray.700");

    return (
        <CorePage location={location}
        buildNumber={import.meta.env.VITE_BUILD_NUMBER}
        {...pageProps}
        topNavProps={ {avatar: { name: undefined, icon: <IconUser />, bg: iconColor, color: "white" }, showLogo: true, customLogo: <Image src={ETRALogo} alt="Logo" maxWidth="300" />}}>
            {children}
        </CorePage>
    );
};
